import Seo from "@/lib/Seo";
import AboutManifesto from "@/sections/AboutManifesto";
import FinalCTA from "@/sections/FinalCTA";

function PageHead({ eyebrow, title, subtitle }) {
  return (
    <header className="bg-navy text-white pt-32 pb-16" style={{ backgroundColor: "var(--navy)" }}>
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <span className="eyebrow mb-5">{eyebrow}</span>
        <h1 className="font-display leading-tight max-w-3xl" style={{ fontSize: "clamp(1.7rem, 3.4vw, 2.9rem)" }}>{title}</h1>
        {subtitle && <p className="mt-5 text-white/75 text-lg max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </header>
  );
}

export { PageHead };

export default function About() {
  return (
    <>
      <Seo path="/about" title="عن سياق" description="من نحن، رؤيتنا ورسالتنا وركائزنا: السياق هو الإطار الذي نبتكر انطلاقًا منه." />
      <PageHead eyebrow="عن سياق" title="السياق هو الأسلوب أو الإطار" subtitle="لسياقك نبتكر" />
      <span id="profile" />
      <AboutManifesto full />
      <FinalCTA />
    </>
  );
}
